export default Object.freeze({
  AUTHENTICATION_TYPE: "authentication.type",
  EXTERNAL_AUTH_CONTAINS_USER_STATE: "external.auth.contains.user.state",
  LDAP_PROVIDER_URL: "ldap.provider.url",
  LDAP_SECURITY_MECHANISM: "ldap.security.mechanism",
  LDAP_SECURITY_PRINCIPAL: "ldap.security.principal",
  LDAP_SECURITY_CREDENTIALS: "ldap.security.credentials",
  LDAP_SCHEMA_ROOT: "ldap.schema.root",
  LDAP_SUBSCHEMA_RDN: "ldap.subschema.rdn",
  AUTH_ATTRIBUTE_USERNAME: "auth.attribute.username",
  AUTH_ATTRIBUTE_FIRSTNAME: "auth.attribute.firstname",
  AUTH_ATTRIBUTE_SURNAME: "auth.attribute.surname",
  AUTH_ATTRIBUTE_CLASSIFICATION: "auth.attribute.classification",
  AUTH_ATTRIBUTE_ROLES: "auth.attribute.role",
  AUTH_ATTRIBUTE_EMAIL: "auth.attribute.email",
  AUTH_ATTRIBUTE_TEAMS: "auth.attribute.team",
  AUTH_DEFAULT_USER_TYPE: "auth.default.user.type",
  AUTH_DEFAULT_CLASSIFICATION: "auth.default.classification",
  AUTH_DEFAULT_TEAMS: "auth.default.teams",
  AUTH_DEFAULT_ROLES: "auth.default.roles",
  AUTH_ALLOW_DATABASE_LOGINS: "allow.database.logins",
  AUTHENTICATION_GOOGLE_ENABLED: "authentication.google.enabled",
  AUTHENTICATION_OKTA_ENABLED: "authentication.okta.enabled",
  ORGANIZATION_LOGO: "organization.logo",
  OIDC_PROVIDER: "oidc.provider",
  OIDC_PROVIDER_CUSTOM_NAME: "oidc.provider.custom.name",
  OIDC_PROVIDER_CUSTOM_DOMAIN: "oidc.provider.custom.domain",
  OIDC_PROVIDER_CUSTOM_CLIENT_ID: "oidc.provider.custom.client.id",
  OIDC_PROVIDER_CUSTOM_CLIENT_SECRET: "oidc.provider.custom.client.secret",
  SAML_IDP_METADATA_URL: "saml.idp.metadata.url",
  SAML_IDP_ISSUER: "saml.idp.issuer",
  SAML_GLOBAL_LOGOUT: "saml.global.logout",
  LOGIN_LOGO: "login.logo",
  REVIEWERS_REQUIRED: "expert.reviewersrequired",
  APPROVERS_REQUIRED: "expert.approversrequired",
  REVIEW_OWN_KNOWLEDGE: "expert.reviewownknowledge",
  APPROVE_OWN_KNOWLEDGE: "expert.approveownknowledge",
  AUTOMATIC_PUBLISH: "expert.automaticpublish",
  AUTOSTART_APPROVAL: "expert.autostartapproval",
  SEARCH_SECONDARY_INFO: "search.secondary.info",
  SEARCH_LANGUAGES: "search.languages",
  WORKFLOW_EMAILS_ENABLED: "notifications.workflow.email.enabled",
  DISCUSSIONS_EMAILS_ENABLED: "notifications.discussions.email.enabled",
  SYSTEM_EMAILS_ENABLED: "notifications.system.email.enabled",
  REWORK_EMAILS_ENABLED: "notifications.rework.email.enabled",
  REQUIRED_READING_EMAILS_ENABLED:
    "notifications.requiredreading.email.enabled",
  WORKFLOW_EMAIL_SUBJECT: "notifications.workflow.email.subject",
  DISCUSSIONS_EMAIL_SUBJECT: "notifications.discussions.email.subject",
  SYSTEM_EMAIL_SUBJECT: "notifications.system.email.subject",
  REQUIRED_READING_EMAIL_SUBJECT: "notifications.requiredreading.email.subject",
  REWORK_EMAIL_SUBJECT: "notifications.rework.email.subject",
  WORKFLOW_EMAIL_TEMPLATE: "notifications.workflow.email.template",
  DISCUSSIONS_EMAIL_TEMPLATE: "notifications.discussions.email.template",
  SYSTEM_EMAIL_TEMPLATE: "notifications.system.email.template",
  REQUIRED_READING_EMAIL_TEMPLATE:
    "notifications.requiredreading.email.template",
  REWORK_EMAIL_TEMPLATE: "notifications.rework.email.template",
  SMTP_SERVER: "smtpserver",
  SMTP_PORT: "smtpport",
  SMTP_USER: "smtpuser",
  SMTP_PASSWORD: "smtppassword",
  SMTP_ENCRYPTION: "smtpencryption",
  SMTP_FROM: "smtpfrom",
  UI_URL: "uiurl",
  SAML_CERTIFICATE: "saml.certificate",
  SAML_REDIRECT_URI: "saml.redirect.uri",
  SAML_BASE_URL: "saml.base.url",
  PDF_TEMPLATES: "pdf.templates",
  AUTO_DOWNLOAD_EXCEL: "auto.download.excel",
  AUTO_DOWNLOAD_WORD: "auto.download.word",
  AUTO_DOWNLOAD_PPT: "auto.download.ppt",
  DISCUSSIONS_ENABLED: "discussions.enabled",
  DISPLAY_NEW_TAB_ICON: "display.new.tab.icon",
  DISPLAY_NEW_DOCUMENT_PORTLET_ICON: "display.new.document.portlet.icon",
  DISPLAY_TOPICS_IN_DOC_TAX_PORTLET: "display.topics.in.doc.tax.portlet",
  OAUTH_MICROSOFT_ID: "oauth.microsoft.id",
  OAUTH_MICROSOFT_SECRET: "oauth.microsoft.secret",
  OAUTH_GOOGLE_ID: "oauth.google.id",
  OAUTH_GOOGLE_SECRET: "oauth.google.secret",
  OAUTH_SALESFORCE_ID: "oauth.salesforce.id",
  OAUTH_SALESFORCE_SECRET: "oauth.salesforce.secret",
  OAUTH_DROPBOX_BUSINESS_ID: "oauth.dropbox.business.id",
  OAUTH_DROPBOX_BUSINESS_SECRET: "oauth.dropbox.business.secret",
  OAUTH_DROPBOX_USER_ID: "oauth.dropbox.user.id",
  OAUTH_DROPBOX_USER_SECRET: "oauth.dropbox.user.secret",
  FRAME_ANCESTOR: "frameancestor",

  WORKFLOW_EMAIL_SUBJECT_REVIEW : "notifications.workflow.email.subject.review",
  WORKFLOW_EMAIL_TEMPLATE_REVIEW : "notifications.workflow.email.template.review",
  WORKFLOW_EMAIL_SUBJECT_APPROVE : "notifications.workflow.email.subject.approve",
  WORKFLOW_EMAIL_TEMPLATE_APPROVE : "notifications.workflow.email.template.approve",
  WORKFLOW_EMAIL_SUBJECT_PUBLISH : "notifications.workflow.email.subject.publish",
  WORKFLOW_EMAIL_TEMPLATE_PUBLISH : "notifications.workflow.email.template.publish",
});
